import React from 'react';
import { Button, SvgIcon } from 'seduo-ui';
import classNames from 'classnames';
const ActionButton = ({ onClick, inputValueSize, isMobile, isCollapsed }) => (<Button color="link" onClick={onClick} className={classNames('search__reset', {
        show: isMobile && isCollapsed ? inputValueSize >= 0 : inputValueSize > 0,
    })} {...(isMobile && isCollapsed
    ? {
        'data-collapse': 'toggle',
        'data-target': '#search',
        'aria-controls': 'search',
    }
    : {})}>
        <SvgIcon kind="CloseCircle" className="search__reset-icon"/>
    </Button>);
ActionButton.defaultProps = {
    isCollapsed: true,
};
export default ActionButton;
